export const getLabelFromValue = ({
  value,
  selections,
}: {
  value: string;
  selections: {
    value: string;
    label: string;
    [key: string]: any;
  }[];
}): string => {
  const matchedSelection = selections.find(
    selection => selection.value === value,
  );
  return matchedSelection?.label || value;
};
